import React from "react";

export const TableTitle = ({ title }: { title: string }) => {
  return <h1 className="font-bold text-xl">{title}</h1>;
};
